import React from 'react';
import { CloseOutlined, WarningFilled } from '@ant-design/icons';
import { BaseAlertBanner } from '@components';
import { AbsoluteWrapper as Wrapper } from '@components/alert-banner/styled';
import { useAppDispatch, useAppSelector } from '@hooks/reduxHooks';
import { useTaskCsv } from '@hooks/useTaskCsv';
import { Trans, useLingui } from '@lingui/react/macro';
import { clearTaskCsvImportState } from '@routes/sidebar/admin-center/creator/___pages___/elements/model/creatorElements.slice.ts';
import { DownloadRejectedTasks } from '@routes/sidebar/admin-center/creator/___pages___/elements/ui/task-element/ui/banners/csv-import-with-errros/styled.tsx';
import { isEmpty } from 'lodash';

interface Props {
    recordsUploaded: number;
    recordsRejected: number;
    filename: string;
}

export const TaskCsvImportWithErrorsBanner: React.FC<Props> = ({ recordsUploaded, recordsRejected, filename }) => {
    const { t } = useLingui();
    const dispatch = useAppDispatch();

    const { downloadTaskCsvIssues } = useTaskCsv();

    const taskCsvIssuesFileContent = useAppSelector(
        (state) => state.adminCenterCreatorElements.taskCsvIssuesFileContent,
    );

    const handleClose = () => {
        void dispatch(clearTaskCsvImportState());
    };

    return (
        <Wrapper $width="40%">
            <BaseAlertBanner
                closable={{
                    onClose: handleClose,
                    closeIcon: <CloseOutlined />,
                }}
                type="warning"
                title={filename}
                description={
                    <>
                        <Trans>
                            {recordsUploaded} records uploaded successfully, {recordsRejected} records error(s) rejected
                        </Trans>

                        {!isEmpty(taskCsvIssuesFileContent) && (
                            <DownloadRejectedTasks
                                onClick={downloadTaskCsvIssues}
                            >{t`Download rejected tasks`}</DownloadRejectedTasks>
                        )}
                    </>
                }
                icon={<WarningFilled />}
            />
        </Wrapper>
    );
};
